import getUUId from "../../utils/uuid";
import app from "../../firebaseConfig/firebaseConfig";
import {get, getDatabase, onValue, ref, set} from "firebase/database";
import {useEffect, useState} from "react";

const db = getDatabase(app);

class _ProductPromoManager {
    constructor() {
        this.productPromos = {};
        this.promoListeners = {};
        this.listenedProductId = {};
        onValue(ref(db, `promotions/products`), snapshot => {
            this.productPromos = snapshot.val() || {};
            this.callPromoListeners();
        })
    }

    callPromoListeners = () => {
        Object.keys(this.promoListeners).forEach(key => {
            const productId = this.listenedProductId[key];
            const listener = this.promoListeners[key];
            if (productId) {
                listener({...(this.productPromos?.[productId] || {})});
            } else {
                listener({...this.productPromos});
            }
        })
    }

    subscribePromoChange(listener, productId) {
        const uuId = getUUId();
        this.promoListeners[uuId] = listener;
        this.listenedProductId[uuId] = productId;

        if (productId) {
            listener({...(this.productPromos?.[productId] || {})});
        } else {
            listener(this.productPromos);
        }

        return () => {
            delete this.promoListeners[uuId];
            delete this.listenedProductId[uuId];
        };
    }

    getAllPromotion = async () => {
        return await get(ref(db, `/promotions`)).then(snapshot => {
            return snapshot.val();
        });
    }

    saveProductPromo = (key, value, callback) => {
        set(ref(db, `/promotions/products/${key}`), value).then(callback);
    }

    saveCodes = (value, callback) => {
        set(ref(db, `/promotions/codes`), value).then(callback);
    }

    saveSingleUseCodes = (value, callback) => {
        set(ref(db, `/promotions/singleUseCodes`), value).then(callback);
    }

    savePersonalPickupCode = (value, callback) => {
        set(ref(db, `/promotions/personalPickup`), value).then(callback);
    }
}


const ProductPromoManager = new _ProductPromoManager();
export default ProductPromoManager;

export function useProductPromo(productId) {
    const [promo, setPromo] = useState({});

    useEffect(() => {
        const unsubscribe = ProductPromoManager.subscribePromoChange(setPromo, productId);
        return () => {
            unsubscribe();
        };
    }, []);

    return promo;
}
